import { AmbientLight, DirectionalLight, Group } from "three";

export default class Lights {
    public instance: Group;
    private ambLight: AmbientLight;
    private dirLight: DirectionalLight;

    constructor() {
        this.instance = new Group();
        this.ambLight = new AmbientLight(0xffffff, 2);
        this.dirLight = new DirectionalLight(0xffffff, 5);
        this.setUpLights();
    }

    private setUpLights() {
        this.dirLight.target = this.instance;
        this.dirLight.position.set(5, 5, 5);
        this.instance.add(this.dirLight)
        this.instance.add(this.ambLight)
    }

    //public turnDownLights() {
    // console.log('turn down lights');
    // this.ambLight.intensity = 2;
    // console.log('turn down lights', this.ambLight.intensity);
    //}
}
